import * as React from "react";
import { Grid, GridColumn, Input } from "semantic-ui-react";
import "./project-new.css";
import MyDatePicker from "../../../components/date-picker/date-picker";
import LabeledInput from "../../../components/labeled-input/labeled-input";
import LabeledTextArea from "../../../components/labeled-textarea/labeled-textarea";
import { KeyValueStore } from "../../../stores/key-value/key-value-store";
import { Municipality } from "../../../stores/municipality/municipality-store";
import { getDesc, getLabel } from "../../../reflection/reflection";
import { ConstructionPermitProject } from "../../../stores/project/project";

export default function ConstructionPermitNew({
                                                  municipalities,
                                                  keyValueStore
                                              }: {
    municipalities: Municipality[];
    keyValueStore: KeyValueStore
}): JSX.Element {
    return (
        <div>
            <Grid columns={2} relaxed={true} stackable={true}>
                <GridColumn largeScreen={16} widescreen={8}>
                    <LabeledInput
                        label="Name"
                        inputElement={<Input type="text" name="name" placeholder="Kurzname Vorhaben (ugs.)"
                                             maxLength={50}/>}
                        required={true}
                    />
                    <LabeledInput
                        label={getLabel(ConstructionPermitProject.prototype, "municipalityName")}
                        desc={getDesc(ConstructionPermitProject.prototype, "municipalityName")}
                        inputElement={
                            <select name="municipality" className="ui selection dropdown">
                                <option disabled selected>
                                    -- Auswählen --
                                </option>
                                {municipalities.map((m) => (
                                    <option
                                        key={m.bfsNr}
                                        value={m.bfsNr}
                                    >
                                        {m.name}
                                    </option>
                                ))}
                            </select>
                        }
                        required={true}
                    />
                    <LabeledInput
                        label={getLabel(ConstructionPermitProject.prototype, "place")}
                        desc={getDesc(ConstructionPermitProject.prototype, "place")}
                        inputElement={<Input type="text" name="place"/>}
                        required={true}
                    />
                    <LabeledInput
                        label={getLabel(ConstructionPermitProject.prototype, "usageCategory")}
                        desc={getDesc(ConstructionPermitProject.prototype, "usageCategory")}
                        inputElement={
                            <select name="usageCategory" className="ui selection dropdown">
                                <option disabled selected>
                                    -- Auswählen --
                                </option>
                                {keyValueStore.usageCategories.map((t) => (
                                    <option
                                        key={t.key}
                                        value={t.key}
                                    >
                                        {t.value}
                                    </option>
                                ))}
                            </select>
                        }
                        required={true}
                    />
                    <LabeledInput
                        label={getLabel(ConstructionPermitProject.prototype, "status")}
                        inputElement={
                            <select name="status" className="ui selection dropdown">
                                <option disabled selected>
                                    -- Auswählen --
                                </option>
                                {keyValueStore.projectStatuses.map((s) => (
                                    <option
                                        key={s.key}
                                        value={s.key}
                                    >
                                        {s.value}
                                    </option>
                                ))}
                            </select>
                        }
                        required={true}
                    />
                    <LabeledInput
                        label={getLabel(ConstructionPermitProject.prototype, "governmentCouncilDecisionNr")}
                        desc={getDesc(ConstructionPermitProject.prototype, "governmentCouncilDecisionNr")}
                        inputElement={<Input type="text" name="governmentCouncilDecisionNr"/>}
                    />
                    <LabeledInput
                        label={getLabel(ConstructionPermitProject.prototype, "ebageNr")}
                        desc={getDesc(ConstructionPermitProject.prototype, "ebageNr")}
                        inputElement={<Input type="text" name="ebageNr"/>}
                        required={true}
                    />
                    <LabeledInput
                        label={getLabel(ConstructionPermitProject.prototype, "enactmentDateDisplayText")}
                        desc={getDesc(ConstructionPermitProject.prototype, "enactmentDateDisplayText")}
                        inputElement={<MyDatePicker name="enactmentDate"/>}
                    />
                    <LabeledInput
                        label={getLabel(ConstructionPermitProject.prototype, "targetArea")}
                        desc={getDesc(ConstructionPermitProject.prototype, "targetArea")}
                        inputElement={<Input type="number" name="targetArea"/>}
                        required={true}
                    />
                    <LabeledInput
                        label={getLabel(ConstructionPermitProject.prototype, "compensationDeadlineDisplayText")}
                        desc={getDesc(ConstructionPermitProject.prototype, "compensationDeadlineDisplayText")}
                        inputElement={<MyDatePicker name="compensationDeadline"/>}
                    />
                    <LabeledInput
                        label={getLabel(ConstructionPermitProject.prototype, "cmiNumberRawi")}
                        desc={getDesc(ConstructionPermitProject.prototype, "cmiNumberRawi")}
                        inputElement={<Input type="text" name="cmiNrRawi"/>}
                    />
                    <LabeledInput
                        label={getLabel(ConstructionPermitProject.prototype, "geometrySource")}
                        desc={getDesc(ConstructionPermitProject.prototype, "geometrySource")}
                        inputElement={<Input type="text" maxLength={50} name="geometrySource"/>}
                    />
                    <LabeledInput
                        label={getLabel(ConstructionPermitProject.prototype, "geometrySourceDateDisplayText")}
                        desc={getDesc(ConstructionPermitProject.prototype, "geometrySourceDateDisplayText")}
                        inputElement={<MyDatePicker name="geometrySourceDate"/>}
                    />
                </GridColumn>
                <GridColumn>
                    <LabeledTextArea label={getLabel(ConstructionPermitProject.prototype, "remarks")} name="remarks"/>
                </GridColumn>
            </Grid>
        </div>
    );
}
